import { useQuery } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export const getSessionConfigOptions = (sessionId: string) =>
  trpcOptions.app.getSessionConfig.queryOptions({ sessionId })

export function useGetSessionConfig(sessionId: string) {
  return useQuery(getSessionConfigOptions(sessionId))
}
